/* eslint-disable */
<template>
  <div>
    <ContactBanner />
    <ContactGrid />
    <ContactForm />
    <LoadingComponent v-if="loading" />
  </div>
</template>

<script>
import ContactBanner from "../components/ContactBanner";
import ContactGrid from "../components/ContactGrid";
import ContactForm from "../components/ContactForm";
import LoadingComponent from "../components/LoadingComponent";

export default {
  name: "Contact",
  components: {
    ContactBanner,
    ContactGrid,
    ContactForm,
    LoadingComponent
  },
  data() {
    return {
      loading: true
    };
  },
  methods: {
    processLoading: function() {
      setTimeout(() => {
        this.closeLoading();
      }, 3000);
    },
    closeLoading: function() {
      if (this.loading) {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.processLoading();
    this.$store.state.showSearch = false;
  }
};
</script>

<style></style>
